import axios from 'axios';
import apiConfig from '../api.config';

export default function setHotelSlugRequest(hotelId, newHotelSlug) {
  const {
    host,
    URIs: { hotelSlug },
  } = apiConfig;

  const uri = `${host}${hotelSlug.replace(':hotelId', hotelId)}`;

  return axios
    .post(uri, JSON.stringify({ slug: newHotelSlug }), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
